import { DynamicFormConfigCommon } from '../types';

export const isVisible = (config: DynamicFormConfigCommon, values: Record<any, any>) => {
  return !config.visibleIf || config.visibleIf(values, config);
};
